<template>
  <div class="page full" id="game">
    <div class="choice" v-if="type != 0 && !hasIdentify">
      <img
        class="header"
        src="https://appatt.sznews.com/luohu/files/2021djxt/src/img/ChoiceTxt.png"
        alt=""
      />

      <div class="container">
        <div class="formgroup">
          <p>请选择身份类型</p>
          <van-dropdown-menu :overlay="false">
            <van-dropdown-item
              v-model="value"
              :options="option"
              :disabled="false"
              @change="onChange"
            />
          </van-dropdown-menu>
        </div>
        <div class="formgroup">
          <p>请选择所属党支部</p>
          <van-dropdown-menu :overlay="false">
            <van-dropdown-item
              :title="option1_title"
              ref="item"
              :disabled="valueable"
            >
              <form action="/">
                <van-search
                  v-model="value2"
                  show-action
                  placeholder="支部搜索"
                  @search="onSearch"
                  @cancel="onCancel"
                  @input="onInput"
                />
              </form>
              <van-cell
                center
                :title="item.text"
                v-for="(item, index) in option1"
                :key="index"
                @click="onConfirm(index)"
                v-show="item.show"
              >
                <template #right-icon>
                  <van-icon
                    name="success"
                    color="#ee0a24"
                    v-if="item.value == value1"
                  />
                </template>
              </van-cell>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
        <div class="formgroup">
          <p>请填写姓名</p>
          <van-cell-group>
            <van-field
              v-model="username"
              placeholder="请输入姓名"
            />
          </van-cell-group>
        </div>
      </div>

      <van-button type="primary" size="large" round @click="onChosen"
        >确 定</van-button
      >
    </div>

    <div class="qna" v-if="hasIdentify && !hasFinishQues">
      <img
        class="banner"
        src="https://appatt.sznews.com/luohu/files/2021djxt/src/img/timu_banner.png"
      />
      <div
        class="questions"
        v-for="(item, index) in quesList"
        :key="index"
        v-show="index == curQues"
      >
        <div class="topinfo flex">
          <div class="questions_tag">{{ item.question_type }}</div>
          <div class="questions_num" :data-options="item.options + '1'">
            <span>{{ index + 1 }}</span
            >/{{ quesList.length }}
          </div>
        </div>
        <p class="question">{{ item.question_content }}</p>
        <!-- {{item}} -->
        <div
          class="option_bar flex"
          v-for="(option, oindex) in item.options"
          :key="oindex"
          @click="onChoose(oindex)"
          v-show="option.value ? option.value.trim() : ''"
        >
          <div class="dot" :class="option.chosen ? 'dot_hover' : ''">
            {{ option.key }}
          </div>
          {{ option.value }}
        </div>

        <van-button
          type="primary"
          size="large"
          round
          block
          color="#e2353f"
          class="next_btn"
          @click="toNextQues"
          >{{ btnText }}</van-button
        >
      </div>
    </div>

    <div class="result_box" v-if="hasFinishQues">
      <div class="view flex_c" v-if="quesRes == 'success'">
        <img
          src="https://appatt.sznews.com/luohu/files/2021djxt/src/img/result_win_img.png"
          alt=""
        />
        <div class="score flex">
          <h1>{{ score }}</h1>
          <span>分</span>
        </div>
        <div class="text">本次答题得分</div>
        <van-button
          type="primary"
          size="large"
          color="#e2353f"
          round
          @click="confirmRes"
          >确 定</van-button
        >
        <van-button
          type="primary"
          size="large"
          color="#e2353f"
          round
          @click="playAgain(0)"
          >再来一次</van-button
        >
        <van-button
          type="primary"
          size="large"
          color="#b3abac"
          round
          @click="toRank"
          >查看排行榜</van-button
        >
      </div>

      <div class="view flex_c" v-if="quesRes == 'error'">
        <img
          src="https://appatt.sznews.com/luohu/files/2021djxt/src/img/result_fail_img.png"
          alt=""
        />

        <van-button
          type="primary"
          size="large"
          color="#e2353f"
          round
          @click="playAgain(1)"
          >再来一次</van-button
        >
        <van-button
          type="primary"
          size="large"
          color="#b3abac"
          round
          @click="toRank"
          v-if="type == 1"
          >查看排行榜</van-button
        >
      </div>
    </div>

    <van-dialog v-model="usernameShow" title="补充个人信息" show-cancel-button @confirm="usernameConfirm" @cancel="usernameCancel" @close="usernameClose">
      <van-field v-model="username" placeholder="请输入真实姓名" />
    </van-dialog>
  </div>
</template>
<script>
import index from "./index.js";

export default {
  ...index
};
</script>

<style lang="scss">
@import "./index.scss";
</style>